import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { StaticFilter, useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import { ButtonTabs } from 'ui/buttons'
import { useAuth } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { autorun } from 'mobx'
import isEqual from 'lodash/isEqual'
import { useTranslation } from '@morningtrain/react-translations'
import { useOnHashChange } from '@morningtrain/react-navigation'

function ShiftEntrySwitchFilter (props) {
  const allTranslation = useTranslation('shifts.entries.list_types.all')
  const autoTranslation = useTranslation('shifts.entries.list_types.auto_checkouts')
  const changeTranslation = useTranslation('shifts.entries.list_types.change_requests')

  const auth = useAuth()

  function buildOptions () {
    return [
      { value: 'all', label: allTranslation },
      !auth.can(Permissions.SHIFTS_MANAGE_AUTO_CHECKOUTS) ? null : { value: 'auto_checkouts', label: autoTranslation },
      !auth.can(Permissions.SHIFTS_MANAGE_CHANGE_REQUESTS) ? null : { value: 'change_requests', label: changeTranslation }
    ].filter(o => o)
  }

  const [options, setOptions] = React.useState(buildOptions())

  React.useEffect(() => {
    const disposer = autorun(() => {
      const nextOptions = buildOptions()
      if (!isEqual(nextOptions, options)) {
        setOptions(nextOptions)
      }
    })

    return () => {
      disposer()
    }
  })

  const {
    name = 'list_type',
    only,
    defaultValue = 'all',
    onChange = () => {},
    allowNull = false
  } = props

  function getDefaultValue () {
    if (location.hash === '#change_requests') {
      return 'change_requests'
    } else if (location.hash === '#auto_checkouts') {
      return 'auto_checkouts'
    } else {
      return defaultValue
    }
  }

  const [value, setValue] = useFilterValue(name, getDefaultValue())

  useWillConstrain(name, value)

  const handleChange = (newValue) => {
    if (newValue === value && allowNull) {
      newValue = null
    }
    location.hash = ''
    onChange(newValue)
    setValue(newValue)
  }

  useOnHashChange(() => {
    if (location.hash === '#change_requests') {
      setValue('change_requests')
    } else if (location.hash === '#auto_checkouts') {
      setValue('auto_checkouts')
    }
  })

  if (options.length === 1) {
    return <StaticFilter name={name} value={options[0].value} />
  }

  return (
    <ButtonTabs classNames={props.className} size={props.size} fullWidth={props.fullWidth}>
      {options.map(option => (
        <button
          key={option.value}
          type='button'
          className={(option.value === value) ? 'active' : 'inactive'}
          onClick={() => handleChange(option.value)}
        >
          <span className='flex items-center justify-center'>
            {/* TODO: Icons for buttons */}
            {option.label}
          </span>
        </button>
      ))}
    </ButtonTabs>
  )
}

ShiftEntrySwitchFilter.defaultProps = {
  label: null,
  only: null
}

ShiftEntrySwitchFilter.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  enum: PropTypes.string.isRequired,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  only: PropTypes.array,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  defaultValue: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool
}

export default observer(ShiftEntrySwitchFilter)
